import React from 'react';
import styled from 'styled-components';
// import { trackAppDownload } from '../utils/analytics';

// Google Ads 전환 추적 함수 타입 선언
declare global {
  interface Window {
    gtag_report_conversion: (url?: string) => boolean;
  }
}

const AppStoreContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    gap: 12px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    gap: 8px;
  }
`;

const StoreButton = styled.a`
  display: inline-block;
  transition: transform 0.2s ease-in-out;
  
  &:hover {
    transform: translateY(-2px);
  }
  
  img {
    height: 54px;
    width: auto;
    
    @media (max-width: 768px) {
      height: 48px;
    }
  }
`;

const WebButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 54px;
  padding: 0 18px;
  min-width: 300px;
  border-radius: 10px;
  background: #000;
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.1px;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.18);
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out, opacity 0.2s ease-in-out;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
    opacity: 0.95;
  }

  @media (max-width: 768px) {
    height: 48px;
    padding: 0 16px;
    min-width: 260px;
    font-size: 14px;
  }
`;

interface AppStoreButtonsProps {
  googlePlayUrl?: string;
  appStoreUrl?: string;
}

// 실제 스토어 링크 (기본값)
const DEFAULT_GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=com.tobeAi.tobe';
const DEFAULT_APP_STORE = 'https://apps.apple.com/us/app/%ED%88%AC%EB%B9%84/id6749519861';
const DEFAULT_WEB_URL = 'https://tobeai.web.app/#/auth';

export const AppStoreButtons: React.FC<AppStoreButtonsProps> = ({
  googlePlayUrl = DEFAULT_GOOGLE_PLAY,
  appStoreUrl = DEFAULT_APP_STORE,
}) => {
  const handleGooglePlayClick = (e: React.MouseEvent) => {
    e.preventDefault();

    // /download 경로로 리다이렉트하면서 파라미터 전달
    const downloadUrl = `/download?platform=google_play&url=${encodeURIComponent(googlePlayUrl)}`;
    window.location.href = downloadUrl;
  };

  const handleAppStoreClick = (e: React.MouseEvent) => {
    e.preventDefault();

    // /download 경로로 리다이렉트하면서 파라미터 전달
    const downloadUrl = `/download?platform=app_store&url=${encodeURIComponent(appStoreUrl)}`;
    window.location.href = downloadUrl;
  };

  const handleWebClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = DEFAULT_WEB_URL;
  };

  return (
    <AppStoreContainer>
      <StoreButton
        href="#"
        aria-label="Google Play에서 다운로드"
        onClick={handleGooglePlayClick}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          alt="Google Play에서 다운로드"
        />
      </StoreButton>

      <StoreButton
        href="#"
        aria-label="App Store에서 다운로드"
        onClick={handleAppStoreClick}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
          alt="App Store에서 다운로드"
        />
      </StoreButton>

      <WebButton
        href={DEFAULT_WEB_URL}
        aria-label="웹에서 체험하기"
        onClick={handleWebClick}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="white" strokeWidth="2" />
          <path d="M3 12H21" stroke="white" strokeWidth="2" />
          <path d="M12 3C14.7614 5.73852 16.1421 8.86926 16.1421 12C16.1421 15.1307 14.7614 18.2615 12 21C9.23858 18.2615 7.85786 15.1307 7.85786 12C7.85786 8.86926 9.23858 5.73852 12 3Z" stroke="white" strokeWidth="2" />
        </svg>
        웹에서 체험하기
      </WebButton>
    </AppStoreContainer>
  );
};
